/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var RecruitmentBusinessType;

(function (RecruitmentBusinessType) {
  RecruitmentBusinessType["RECRUITMENT_AGENCY"] = "recruitment_agency";
  RecruitmentBusinessType["UMBRELLA_PAYROLL_BUSINESS"] = "umbrella_payroll_business";
  RecruitmentBusinessType["RECRUITMENT_AGENCY_INCLUDING_UMBRELLA_ACTIVITIES"] = "recruitment_agency_including_umbrella_activities";
})(RecruitmentBusinessType || (RecruitmentBusinessType = {}));